export default __webpack_public_path__ + "static/media/fileData.ce93e26d.png";